import React, {useState, useEffect, useMemo, useRef} from "react";
import { Link } from "gatsby";
import classNames from 'classnames';
//import containerStyles from "./container.module.css"
//import HeaderTree from "./headerTree"
//import Container from "./container"
import SidebarLogo from "./sidebarLogo"

export default (props) => {

  //console.log(props);

  const {
    components,
    page,
    show,
    onToggleSidebar
  } = props;

  /*
  let directives = [];
  directives.push({
    title: 'title1',
    path: '/',
    active: true
  })
  directives.push({
    title: 'title2',
    path: '/',
    active: true
  })
  */

  const [mobileShow, setMobileShow] = useState(show);

  useMemo(()=>{
    setMobileShow(show);
  }, [show]);


  let introductionItemClasses = "cd-nav-item";
  let introductionLinkClasses = "cd-nav-link";

  switch (page){
    case 'introduction':
    introductionItemClasses = "cd-nav-item cd-active";
    introductionLinkClasses = "cd-nav-link cd-active active";
    break;
    default:
  }

  // scroll

  const [scrollPos, setScrollPos] = useState(0);
  //console.log(scrollPos);

  const ref = useRef();

  useEffect(()=>{
    ref.current.scrollTop = React.scrollPos;
  }, []);


  const onClick = ()=>{
    //setMobileShow(false);
    onToggleSidebar && onToggleSidebar();
  }

  const onScroll = e=>{
    //setScrollPos(e.target.scrollTop);
    React.scrollPos = e.target.scrollTop;
  }


  // render

  const classes = classNames(
    'cd-sidebar',
    mobileShow ? 'cd-show' : null
  );
  //console.log("classes", classes);

  return (
    <aside className={classes}>

      <button onClick={onClick} type="button" className="cd-close-button"></button>

      <SidebarLogo/>

      <nav
        className="cd-sidebar-nav pb-4"
        aria-label="main navigation"
        onScroll={onScroll}
        ref={ref}
      >

        <div className="cd-nav-item">
          <Link className="cd-nav-link cd-nav-dropdown-toggle" to="/introduction">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className="cd-nav-icon" width="64" height="64" viewBox="0 0 64 64">
            <title>energy</title>
            <path d="M40 26v-24h-4.012l-27.941 38h16.953v22h3.975l28.125-36zM15.953 36l20.047-27.264v21.264h12.9l-19.9 25.471v-19.471z"></path>
            </svg>
            Getting started
          </Link>
          <ul className="cd-nav-dropdown-items mh-100">
            <li className={introductionItemClasses}>
              <Link
                className={introductionLinkClasses}
                to="/introduction"
              >
                Introduction
              </Link>
            </li>
          </ul>
        </div>

        <div className="cd-nav-item cd-nav-dropdown-toggle cd-open">

          <Link className="cd-nav-link cd-nav-dropdown-toggle active" to="/components/CAlert">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className="cd-nav-icon" width="64" height="64" viewBox="0 0 64 64">
              <title>d</title>
              <path d="M55.46 16.17l-21.419-12.366c-0.574-0.336-1.264-0.534-2-0.534s-1.426 0.198-2.019 0.545l0.019-0.010-21.419 12.366c-1.202 0.706-1.998 1.992-2 3.464v24.733c0.002 1.472 0.798 2.758 1.981 3.454l0.019 0.010 21.419 12.366c0.574 0.336 1.264 0.534 2 0.534s1.426-0.198 2.019-0.544l-0.019 0.010 21.419-12.366c1.202-0.706 1.997-1.992 2-3.464v-24.733c-0.002-1.472-0.798-2.758-1.981-3.454l-0.019-0.010zM53.46 19.634v22.172l-19.419-10.976v-22.408zM10.623 19.634l19.419-11.211v22.401l-19.419 10.976zM32.042 56.732l-19.644-11.342 19.638-11.1 19.644 11.103z"></path>
            </svg>
            Components
          </Link>
          <ul className="cd-nav-dropdown-items mh-100">
            {
              components.map((item, i)=>{

                //console.log(item);
                if (!item)
                return '';
                let classes = "cd-nav-item";
                if (item.isActive)
                  classes += " cd-active";
                let linkClasses = "cd-nav-link";
                if (item.isActive)
                  linkClasses += " cd-active active";
                return (
                  <li key={i} className={classes} >
                    <Link
                      className={linkClasses}
                      to={'/'+item.path}
                      state={item.state}
                    >
                      {item.title}
                    </Link>
                  </li>
                )

              })
            }
          </ul>

        </div>

      </nav>

    </aside>
  )

}
